export default __webpack_public_path__ + "static/media/73.f6bd083c.jpeg";